module.exports = __webpack_public_path__ + "static/banner.c8cfc45d.jpg";